import { render, staticRenderFns } from "./tableColumn.vue?vue&type=template&id=74b26909&"
import script from "./tableColumn.vue?vue&type=script&lang=js&"
export * from "./tableColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports